/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeCouponScreenRouteImport } from './routes/welcome-coupon-screen'
import { Route as WashStartGuideRouteImport } from './routes/wash-start-guide'
import { Route as V5CashPaymentScreenRouteImport } from './routes/v5-cash-payment-screen'
import { Route as TerminalTestRouteImport } from './routes/terminal-test'
import { Route as StartScreenRouteImport } from './routes/start-screen'
import { Route as SecretRouteImport } from './routes/secret'
import { Route as RegistrationScreenRouteImport } from './routes/registration-screen'
import { Route as RecyclerRefillRouteImport } from './routes/recycler-refill'
import { Route as ProfileEditScreenRouteImport } from './routes/profile-edit-screen'
import { Route as PaymentCompleteRouteImport } from './routes/payment-complete'
import { Route as PaymentCardScreenRouteImport } from './routes/payment-card-screen'
import { Route as PaymentBalanceScreenRouteImport } from './routes/payment-balance-screen'
import { Route as PasswordReminderRouteImport } from './routes/password-reminder'
import { Route as MachineTypeSelectorScreenRouteImport } from './routes/machine-type-selector-screen'
import { Route as LoginScreenRouteImport } from './routes/login-screen'
import { Route as LoginOptionSelectorScreenRouteImport } from './routes/login-option-selector-screen'
import { Route as InvoiceQuestionScreenRouteImport } from './routes/invoice-question-screen'
import { Route as BubblesLovesYouScreenRouteImport } from './routes/bubbles-loves-you-screen'
import { Route as BalanceReplenishCashScreenRouteImport } from './routes/balance-replenish-cash-screen'
import { Route as ActiveReservationsScreenRouteImport } from './routes/active-reservations-screen'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PaymentMachineTypeRouteImport } from './routes/payment.$machineType'
import { Route as MachineSelectorScreenMachineTypeRouteImport } from './routes/machine-selector-screen.$machine-type'
import { Route as InvoiceGenerationScreenNonceRouteImport } from './routes/invoice-generation-screen.$nonce'
import { Route as DryerBundleSelectorScreenMachineIdRouteImport } from './routes/dryer-bundle-selector-screen.$machineId'
import { Route as PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125RouteImport } from './routes/payment-selector-screen.$machineId.{-$dryerBundleId}'
import { Route as CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125RouteImport } from './routes/coupon-screen.{-$machineId}.{-$dryerBundleId}'

const WelcomeCouponScreenRoute = WelcomeCouponScreenRouteImport.update({
  id: '/welcome-coupon-screen',
  path: '/welcome-coupon-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const WashStartGuideRoute = WashStartGuideRouteImport.update({
  id: '/wash-start-guide',
  path: '/wash-start-guide',
  getParentRoute: () => rootRouteImport,
} as any)
const V5CashPaymentScreenRoute = V5CashPaymentScreenRouteImport.update({
  id: '/v5-cash-payment-screen',
  path: '/v5-cash-payment-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const TerminalTestRoute = TerminalTestRouteImport.update({
  id: '/terminal-test',
  path: '/terminal-test',
  getParentRoute: () => rootRouteImport,
} as any)
const StartScreenRoute = StartScreenRouteImport.update({
  id: '/start-screen',
  path: '/start-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretRoute = SecretRouteImport.update({
  id: '/secret',
  path: '/secret',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationScreenRoute = RegistrationScreenRouteImport.update({
  id: '/registration-screen',
  path: '/registration-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const RecyclerRefillRoute = RecyclerRefillRouteImport.update({
  id: '/recycler-refill',
  path: '/recycler-refill',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditScreenRoute = ProfileEditScreenRouteImport.update({
  id: '/profile-edit-screen',
  path: '/profile-edit-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCompleteRoute = PaymentCompleteRouteImport.update({
  id: '/payment-complete',
  path: '/payment-complete',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCardScreenRoute = PaymentCardScreenRouteImport.update({
  id: '/payment-card-screen',
  path: '/payment-card-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentBalanceScreenRoute = PaymentBalanceScreenRouteImport.update({
  id: '/payment-balance-screen',
  path: '/payment-balance-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordReminderRoute = PasswordReminderRouteImport.update({
  id: '/password-reminder',
  path: '/password-reminder',
  getParentRoute: () => rootRouteImport,
} as any)
const MachineTypeSelectorScreenRoute =
  MachineTypeSelectorScreenRouteImport.update({
    id: '/machine-type-selector-screen',
    path: '/machine-type-selector-screen',
    getParentRoute: () => rootRouteImport,
  } as any)
const LoginScreenRoute = LoginScreenRouteImport.update({
  id: '/login-screen',
  path: '/login-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginOptionSelectorScreenRoute =
  LoginOptionSelectorScreenRouteImport.update({
    id: '/login-option-selector-screen',
    path: '/login-option-selector-screen',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoiceQuestionScreenRoute = InvoiceQuestionScreenRouteImport.update({
  id: '/invoice-question-screen',
  path: '/invoice-question-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const BubblesLovesYouScreenRoute = BubblesLovesYouScreenRouteImport.update({
  id: '/bubbles-loves-you-screen',
  path: '/bubbles-loves-you-screen',
  getParentRoute: () => rootRouteImport,
} as any)
const BalanceReplenishCashScreenRoute =
  BalanceReplenishCashScreenRouteImport.update({
    id: '/balance-replenish-cash-screen',
    path: '/balance-replenish-cash-screen',
    getParentRoute: () => rootRouteImport,
  } as any)
const ActiveReservationsScreenRoute =
  ActiveReservationsScreenRouteImport.update({
    id: '/active-reservations-screen',
    path: '/active-reservations-screen',
    getParentRoute: () => rootRouteImport,
  } as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentMachineTypeRoute = PaymentMachineTypeRouteImport.update({
  id: '/payment/$machineType',
  path: '/payment/$machineType',
  getParentRoute: () => rootRouteImport,
} as any)
const MachineSelectorScreenMachineTypeRoute =
  MachineSelectorScreenMachineTypeRouteImport.update({
    id: '/machine-selector-screen/$machine-type',
    path: '/machine-selector-screen/$machine-type',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoiceGenerationScreenNonceRoute =
  InvoiceGenerationScreenNonceRouteImport.update({
    id: '/invoice-generation-screen/$nonce',
    path: '/invoice-generation-screen/$nonce',
    getParentRoute: () => rootRouteImport,
  } as any)
const DryerBundleSelectorScreenMachineIdRoute =
  DryerBundleSelectorScreenMachineIdRouteImport.update({
    id: '/dryer-bundle-selector-screen/$machineId',
    path: '/dryer-bundle-selector-screen/$machineId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route =
  PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125RouteImport.update({
    id: '/payment-selector-screen/$machineId/{-$dryerBundleId}',
    path: '/payment-selector-screen/$machineId/{-$dryerBundleId}',
    getParentRoute: () => rootRouteImport,
  } as any)
const CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route =
  CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125RouteImport.update(
    {
      id: '/coupon-screen/{-$machineId}/{-$dryerBundleId}',
      path: '/coupon-screen/{-$machineId}/{-$dryerBundleId}',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/active-reservations-screen': typeof ActiveReservationsScreenRoute
  '/balance-replenish-cash-screen': typeof BalanceReplenishCashScreenRoute
  '/bubbles-loves-you-screen': typeof BubblesLovesYouScreenRoute
  '/invoice-question-screen': typeof InvoiceQuestionScreenRoute
  '/login-option-selector-screen': typeof LoginOptionSelectorScreenRoute
  '/login-screen': typeof LoginScreenRoute
  '/machine-type-selector-screen': typeof MachineTypeSelectorScreenRoute
  '/password-reminder': typeof PasswordReminderRoute
  '/payment-balance-screen': typeof PaymentBalanceScreenRoute
  '/payment-card-screen': typeof PaymentCardScreenRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/profile-edit-screen': typeof ProfileEditScreenRoute
  '/recycler-refill': typeof RecyclerRefillRoute
  '/registration-screen': typeof RegistrationScreenRoute
  '/secret': typeof SecretRoute
  '/start-screen': typeof StartScreenRoute
  '/terminal-test': typeof TerminalTestRoute
  '/v5-cash-payment-screen': typeof V5CashPaymentScreenRoute
  '/wash-start-guide': typeof WashStartGuideRoute
  '/welcome-coupon-screen': typeof WelcomeCouponScreenRoute
  '/dryer-bundle-selector-screen/$machineId': typeof DryerBundleSelectorScreenMachineIdRoute
  '/invoice-generation-screen/$nonce': typeof InvoiceGenerationScreenNonceRoute
  '/machine-selector-screen/$machine-type': typeof MachineSelectorScreenMachineTypeRoute
  '/payment/$machineType': typeof PaymentMachineTypeRoute
  '/coupon-screen/{-$machineId}/{-$dryerBundleId}': typeof CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route
  '/payment-selector-screen/$machineId/{-$dryerBundleId}': typeof PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/active-reservations-screen': typeof ActiveReservationsScreenRoute
  '/balance-replenish-cash-screen': typeof BalanceReplenishCashScreenRoute
  '/bubbles-loves-you-screen': typeof BubblesLovesYouScreenRoute
  '/invoice-question-screen': typeof InvoiceQuestionScreenRoute
  '/login-option-selector-screen': typeof LoginOptionSelectorScreenRoute
  '/login-screen': typeof LoginScreenRoute
  '/machine-type-selector-screen': typeof MachineTypeSelectorScreenRoute
  '/password-reminder': typeof PasswordReminderRoute
  '/payment-balance-screen': typeof PaymentBalanceScreenRoute
  '/payment-card-screen': typeof PaymentCardScreenRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/profile-edit-screen': typeof ProfileEditScreenRoute
  '/recycler-refill': typeof RecyclerRefillRoute
  '/registration-screen': typeof RegistrationScreenRoute
  '/secret': typeof SecretRoute
  '/start-screen': typeof StartScreenRoute
  '/terminal-test': typeof TerminalTestRoute
  '/v5-cash-payment-screen': typeof V5CashPaymentScreenRoute
  '/wash-start-guide': typeof WashStartGuideRoute
  '/welcome-coupon-screen': typeof WelcomeCouponScreenRoute
  '/dryer-bundle-selector-screen/$machineId': typeof DryerBundleSelectorScreenMachineIdRoute
  '/invoice-generation-screen/$nonce': typeof InvoiceGenerationScreenNonceRoute
  '/machine-selector-screen/$machine-type': typeof MachineSelectorScreenMachineTypeRoute
  '/payment/$machineType': typeof PaymentMachineTypeRoute
  '/coupon-screen/{-$machineId}/{-$dryerBundleId}': typeof CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route
  '/payment-selector-screen/$machineId/{-$dryerBundleId}': typeof PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/active-reservations-screen': typeof ActiveReservationsScreenRoute
  '/balance-replenish-cash-screen': typeof BalanceReplenishCashScreenRoute
  '/bubbles-loves-you-screen': typeof BubblesLovesYouScreenRoute
  '/invoice-question-screen': typeof InvoiceQuestionScreenRoute
  '/login-option-selector-screen': typeof LoginOptionSelectorScreenRoute
  '/login-screen': typeof LoginScreenRoute
  '/machine-type-selector-screen': typeof MachineTypeSelectorScreenRoute
  '/password-reminder': typeof PasswordReminderRoute
  '/payment-balance-screen': typeof PaymentBalanceScreenRoute
  '/payment-card-screen': typeof PaymentCardScreenRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/profile-edit-screen': typeof ProfileEditScreenRoute
  '/recycler-refill': typeof RecyclerRefillRoute
  '/registration-screen': typeof RegistrationScreenRoute
  '/secret': typeof SecretRoute
  '/start-screen': typeof StartScreenRoute
  '/terminal-test': typeof TerminalTestRoute
  '/v5-cash-payment-screen': typeof V5CashPaymentScreenRoute
  '/wash-start-guide': typeof WashStartGuideRoute
  '/welcome-coupon-screen': typeof WelcomeCouponScreenRoute
  '/dryer-bundle-selector-screen/$machineId': typeof DryerBundleSelectorScreenMachineIdRoute
  '/invoice-generation-screen/$nonce': typeof InvoiceGenerationScreenNonceRoute
  '/machine-selector-screen/$machine-type': typeof MachineSelectorScreenMachineTypeRoute
  '/payment/$machineType': typeof PaymentMachineTypeRoute
  '/coupon-screen/{-$machineId}/{-$dryerBundleId}': typeof CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route
  '/payment-selector-screen/$machineId/{-$dryerBundleId}': typeof PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/active-reservations-screen'
    | '/balance-replenish-cash-screen'
    | '/bubbles-loves-you-screen'
    | '/invoice-question-screen'
    | '/login-option-selector-screen'
    | '/login-screen'
    | '/machine-type-selector-screen'
    | '/password-reminder'
    | '/payment-balance-screen'
    | '/payment-card-screen'
    | '/payment-complete'
    | '/profile-edit-screen'
    | '/recycler-refill'
    | '/registration-screen'
    | '/secret'
    | '/start-screen'
    | '/terminal-test'
    | '/v5-cash-payment-screen'
    | '/wash-start-guide'
    | '/welcome-coupon-screen'
    | '/dryer-bundle-selector-screen/$machineId'
    | '/invoice-generation-screen/$nonce'
    | '/machine-selector-screen/$machine-type'
    | '/payment/$machineType'
    | '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
    | '/payment-selector-screen/$machineId/{-$dryerBundleId}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/active-reservations-screen'
    | '/balance-replenish-cash-screen'
    | '/bubbles-loves-you-screen'
    | '/invoice-question-screen'
    | '/login-option-selector-screen'
    | '/login-screen'
    | '/machine-type-selector-screen'
    | '/password-reminder'
    | '/payment-balance-screen'
    | '/payment-card-screen'
    | '/payment-complete'
    | '/profile-edit-screen'
    | '/recycler-refill'
    | '/registration-screen'
    | '/secret'
    | '/start-screen'
    | '/terminal-test'
    | '/v5-cash-payment-screen'
    | '/wash-start-guide'
    | '/welcome-coupon-screen'
    | '/dryer-bundle-selector-screen/$machineId'
    | '/invoice-generation-screen/$nonce'
    | '/machine-selector-screen/$machine-type'
    | '/payment/$machineType'
    | '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
    | '/payment-selector-screen/$machineId/{-$dryerBundleId}'
  id:
    | '__root__'
    | '/'
    | '/active-reservations-screen'
    | '/balance-replenish-cash-screen'
    | '/bubbles-loves-you-screen'
    | '/invoice-question-screen'
    | '/login-option-selector-screen'
    | '/login-screen'
    | '/machine-type-selector-screen'
    | '/password-reminder'
    | '/payment-balance-screen'
    | '/payment-card-screen'
    | '/payment-complete'
    | '/profile-edit-screen'
    | '/recycler-refill'
    | '/registration-screen'
    | '/secret'
    | '/start-screen'
    | '/terminal-test'
    | '/v5-cash-payment-screen'
    | '/wash-start-guide'
    | '/welcome-coupon-screen'
    | '/dryer-bundle-selector-screen/$machineId'
    | '/invoice-generation-screen/$nonce'
    | '/machine-selector-screen/$machine-type'
    | '/payment/$machineType'
    | '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
    | '/payment-selector-screen/$machineId/{-$dryerBundleId}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActiveReservationsScreenRoute: typeof ActiveReservationsScreenRoute
  BalanceReplenishCashScreenRoute: typeof BalanceReplenishCashScreenRoute
  BubblesLovesYouScreenRoute: typeof BubblesLovesYouScreenRoute
  InvoiceQuestionScreenRoute: typeof InvoiceQuestionScreenRoute
  LoginOptionSelectorScreenRoute: typeof LoginOptionSelectorScreenRoute
  LoginScreenRoute: typeof LoginScreenRoute
  MachineTypeSelectorScreenRoute: typeof MachineTypeSelectorScreenRoute
  PasswordReminderRoute: typeof PasswordReminderRoute
  PaymentBalanceScreenRoute: typeof PaymentBalanceScreenRoute
  PaymentCardScreenRoute: typeof PaymentCardScreenRoute
  PaymentCompleteRoute: typeof PaymentCompleteRoute
  ProfileEditScreenRoute: typeof ProfileEditScreenRoute
  RecyclerRefillRoute: typeof RecyclerRefillRoute
  RegistrationScreenRoute: typeof RegistrationScreenRoute
  SecretRoute: typeof SecretRoute
  StartScreenRoute: typeof StartScreenRoute
  TerminalTestRoute: typeof TerminalTestRoute
  V5CashPaymentScreenRoute: typeof V5CashPaymentScreenRoute
  WashStartGuideRoute: typeof WashStartGuideRoute
  WelcomeCouponScreenRoute: typeof WelcomeCouponScreenRoute
  DryerBundleSelectorScreenMachineIdRoute: typeof DryerBundleSelectorScreenMachineIdRoute
  InvoiceGenerationScreenNonceRoute: typeof InvoiceGenerationScreenNonceRoute
  MachineSelectorScreenMachineTypeRoute: typeof MachineSelectorScreenMachineTypeRoute
  PaymentMachineTypeRoute: typeof PaymentMachineTypeRoute
  CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route: typeof CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route
  PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route: typeof PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome-coupon-screen': {
      id: '/welcome-coupon-screen'
      path: '/welcome-coupon-screen'
      fullPath: '/welcome-coupon-screen'
      preLoaderRoute: typeof WelcomeCouponScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wash-start-guide': {
      id: '/wash-start-guide'
      path: '/wash-start-guide'
      fullPath: '/wash-start-guide'
      preLoaderRoute: typeof WashStartGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v5-cash-payment-screen': {
      id: '/v5-cash-payment-screen'
      path: '/v5-cash-payment-screen'
      fullPath: '/v5-cash-payment-screen'
      preLoaderRoute: typeof V5CashPaymentScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terminal-test': {
      id: '/terminal-test'
      path: '/terminal-test'
      fullPath: '/terminal-test'
      preLoaderRoute: typeof TerminalTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start-screen': {
      id: '/start-screen'
      path: '/start-screen'
      fullPath: '/start-screen'
      preLoaderRoute: typeof StartScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secret': {
      id: '/secret'
      path: '/secret'
      fullPath: '/secret'
      preLoaderRoute: typeof SecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration-screen': {
      id: '/registration-screen'
      path: '/registration-screen'
      fullPath: '/registration-screen'
      preLoaderRoute: typeof RegistrationScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recycler-refill': {
      id: '/recycler-refill'
      path: '/recycler-refill'
      fullPath: '/recycler-refill'
      preLoaderRoute: typeof RecyclerRefillRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile-edit-screen': {
      id: '/profile-edit-screen'
      path: '/profile-edit-screen'
      fullPath: '/profile-edit-screen'
      preLoaderRoute: typeof ProfileEditScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-complete': {
      id: '/payment-complete'
      path: '/payment-complete'
      fullPath: '/payment-complete'
      preLoaderRoute: typeof PaymentCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-card-screen': {
      id: '/payment-card-screen'
      path: '/payment-card-screen'
      fullPath: '/payment-card-screen'
      preLoaderRoute: typeof PaymentCardScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-balance-screen': {
      id: '/payment-balance-screen'
      path: '/payment-balance-screen'
      fullPath: '/payment-balance-screen'
      preLoaderRoute: typeof PaymentBalanceScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reminder': {
      id: '/password-reminder'
      path: '/password-reminder'
      fullPath: '/password-reminder'
      preLoaderRoute: typeof PasswordReminderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machine-type-selector-screen': {
      id: '/machine-type-selector-screen'
      path: '/machine-type-selector-screen'
      fullPath: '/machine-type-selector-screen'
      preLoaderRoute: typeof MachineTypeSelectorScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-screen': {
      id: '/login-screen'
      path: '/login-screen'
      fullPath: '/login-screen'
      preLoaderRoute: typeof LoginScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-option-selector-screen': {
      id: '/login-option-selector-screen'
      path: '/login-option-selector-screen'
      fullPath: '/login-option-selector-screen'
      preLoaderRoute: typeof LoginOptionSelectorScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice-question-screen': {
      id: '/invoice-question-screen'
      path: '/invoice-question-screen'
      fullPath: '/invoice-question-screen'
      preLoaderRoute: typeof InvoiceQuestionScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bubbles-loves-you-screen': {
      id: '/bubbles-loves-you-screen'
      path: '/bubbles-loves-you-screen'
      fullPath: '/bubbles-loves-you-screen'
      preLoaderRoute: typeof BubblesLovesYouScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/balance-replenish-cash-screen': {
      id: '/balance-replenish-cash-screen'
      path: '/balance-replenish-cash-screen'
      fullPath: '/balance-replenish-cash-screen'
      preLoaderRoute: typeof BalanceReplenishCashScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/active-reservations-screen': {
      id: '/active-reservations-screen'
      path: '/active-reservations-screen'
      fullPath: '/active-reservations-screen'
      preLoaderRoute: typeof ActiveReservationsScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/$machineType': {
      id: '/payment/$machineType'
      path: '/payment/$machineType'
      fullPath: '/payment/$machineType'
      preLoaderRoute: typeof PaymentMachineTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machine-selector-screen/$machine-type': {
      id: '/machine-selector-screen/$machine-type'
      path: '/machine-selector-screen/$machine-type'
      fullPath: '/machine-selector-screen/$machine-type'
      preLoaderRoute: typeof MachineSelectorScreenMachineTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice-generation-screen/$nonce': {
      id: '/invoice-generation-screen/$nonce'
      path: '/invoice-generation-screen/$nonce'
      fullPath: '/invoice-generation-screen/$nonce'
      preLoaderRoute: typeof InvoiceGenerationScreenNonceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dryer-bundle-selector-screen/$machineId': {
      id: '/dryer-bundle-selector-screen/$machineId'
      path: '/dryer-bundle-selector-screen/$machineId'
      fullPath: '/dryer-bundle-selector-screen/$machineId'
      preLoaderRoute: typeof DryerBundleSelectorScreenMachineIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-selector-screen/$machineId/{-$dryerBundleId}': {
      id: '/payment-selector-screen/$machineId/{-$dryerBundleId}'
      path: '/payment-selector-screen/$machineId/{-$dryerBundleId}'
      fullPath: '/payment-selector-screen/$machineId/{-$dryerBundleId}'
      preLoaderRoute: typeof PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coupon-screen/{-$machineId}/{-$dryerBundleId}': {
      id: '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
      path: '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
      fullPath: '/coupon-screen/{-$machineId}/{-$dryerBundleId}'
      preLoaderRoute: typeof CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActiveReservationsScreenRoute: ActiveReservationsScreenRoute,
  BalanceReplenishCashScreenRoute: BalanceReplenishCashScreenRoute,
  BubblesLovesYouScreenRoute: BubblesLovesYouScreenRoute,
  InvoiceQuestionScreenRoute: InvoiceQuestionScreenRoute,
  LoginOptionSelectorScreenRoute: LoginOptionSelectorScreenRoute,
  LoginScreenRoute: LoginScreenRoute,
  MachineTypeSelectorScreenRoute: MachineTypeSelectorScreenRoute,
  PasswordReminderRoute: PasswordReminderRoute,
  PaymentBalanceScreenRoute: PaymentBalanceScreenRoute,
  PaymentCardScreenRoute: PaymentCardScreenRoute,
  PaymentCompleteRoute: PaymentCompleteRoute,
  ProfileEditScreenRoute: ProfileEditScreenRoute,
  RecyclerRefillRoute: RecyclerRefillRoute,
  RegistrationScreenRoute: RegistrationScreenRoute,
  SecretRoute: SecretRoute,
  StartScreenRoute: StartScreenRoute,
  TerminalTestRoute: TerminalTestRoute,
  V5CashPaymentScreenRoute: V5CashPaymentScreenRoute,
  WashStartGuideRoute: WashStartGuideRoute,
  WelcomeCouponScreenRoute: WelcomeCouponScreenRoute,
  DryerBundleSelectorScreenMachineIdRoute:
    DryerBundleSelectorScreenMachineIdRoute,
  InvoiceGenerationScreenNonceRoute: InvoiceGenerationScreenNonceRoute,
  MachineSelectorScreenMachineTypeRoute: MachineSelectorScreenMachineTypeRoute,
  PaymentMachineTypeRoute: PaymentMachineTypeRoute,
  CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route:
    CouponScreenChar123MachineIdChar125Char123DryerBundleIdChar125Route,
  PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route:
    PaymentSelectorScreenMachineIdChar123DryerBundleIdChar125Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
